<template>
    <main>
        <div class="facilities-header">
            <h1 class="display-m">Buildings</h1>
            <TabComponent :tabs="tabs" :active-tab="activeTab" @tab-changed="updateActiveTab" />
        </div>
        <div class="tab-content">
            <component v-if="activeComponent" :is="activeComponent"></component>
            <p v-else>No hay contenido disponible.</p>
        </div>
    </main>
</template>

<style scoped>
main {
    display: flex;
    padding: 24px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    flex-shrink: 0;
}

.tab-content {
    width: 100%;
}

.facilities-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    align-self: stretch;
}

@media screen and (max-width: 640px) {
    .facilities-header {
        flex-direction: column;
        gap: 12px;
    }
}
</style>

<script>
import { markRaw } from 'vue';

import TabComponent from '@/components/core/TabComponent.vue';
import BuildingsSettingsView from './BuildingsSettingsView.vue';
import BuildingsShowView from './BuildingsShowView.vue';

export default {
    name: 'BuildingsView',
    components: {
        TabComponent
    },
    data() {
        return {
            tabs: [
                { name: 'facilities', route: './BuildingsShowView.vue', label: 'Facilities', component: markRaw(BuildingsShowView), disabled: false },
                { name: 'settings', route: './BuildingsSettingsView.vue', label: 'Settings', component: markRaw(BuildingsSettingsView), disabled: true }
            ],
            activeTab: 'facilities',
        };
    },
    computed: {
        activeComponent() {
            const tab = this.tabs.find(tab => tab.name === this.activeTab);
            console.log('activeTab:', this.activeTab);
            console.log('Found tab:', tab);
            return tab ? tab.component : null
        }
    },
    methods: {
        updateActiveTab(newTab) {
            this.activeTab = newTab;
        }
    }
}
</script>